import { render, staticRenderFns } from "./LeaseholdAlterations.vue?vue&type=template&id=bfefd648&"
import script from "./LeaseholdAlterations.vue?vue&type=script&lang=js&"
export * from "./LeaseholdAlterations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports